<p-card header="Controller List - All installations" class="min-w-0">
  @if (!controllerService.errorMessage()) {
    <app-controller-list
      [controllers]="controllerService.controllers()"
      [isLoading]="controllerService.isLoading()"
    />
  }
</p-card>
